import { gql } from '@apollo/client/core';

export const SHARED_JOBS_MUTATION = gql`
  mutation sharedJob($input: SharedJobInput!) {
    sharedJob(input: $input) {
      status
      sharedEmails
      unsharedEmails
      invalidEmailFormat
      invalidEmails
    }
  }
`;

export default {
  SHARED_JOBS_MUTATION,
};
